import { render, staticRenderFns } from "./FollowUpCompaniesContent.vue?vue&type=template&id=7fdf1402"
import script from "./FollowUpCompaniesContent.vue?vue&type=script&lang=js"
export * from "./FollowUpCompaniesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports